import { PREFERENCES } from "constants/Preferences";
import _ from "lodash";

export function getItem(key) {
  return localStorage.getItem(key);
}

export function setItem(key, value) {
  return localStorage.setItem(key, value);
}

export function getItemBase64(key) {
  const data = localStorage.getItem(key);
  if (_.isNil(data)) return null;
  const parsedData = JSON.parse(atob(data));
  if (key === PREFERENCES.UNITS) {
    return _.mapValues(parsedData, (data) => parsedCustomUnitTab(data));
  }
  return parsedData;
}

export function setItemBase64(key, value) {
  const data = btoa(JSON.stringify(value));
  return localStorage.setItem(key, data);
}

export function removeItem(key) {
  return localStorage.removeItem(key);
}

export function parsedCustomUnitTab(data) {
  const isOldVersion =
    _.isArray(data) && _.every(data, (item) => !_.isPlainObject(item));

  if (isOldVersion)
    return [
      {
        name: "Custom",
        units: data,
      },
    ];

  return data;
}
